<template>
  <div class="header">
    <div class="left">
      <p><img src="../assets/login/logo.png" alt="" /></p>
    </div>
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        <!-- <i class="el-icon-s-unfold" style="cursor: pointer"></i> -->
        退出登录
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    // 退出登录
    handleCommand() {
      this.$confirm("确定退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("LogOut").then(() => {
            // window.sessionStorage.setItem("activerouter", '/quality')
            location.href = "/login";
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  background: #ffffff;
  box-shadow: inset 0px -1px 0px 0px #ebebeb;
  padding: 0 32px 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
    display: flex;
    align-items: center;
    p {
      width: 113px;
      height: 27px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  ul {
    display: flex;
    li {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 1px solid #333;
      margin-right: 16px;
    }
  }
}
</style>
